import { useEffect } from "react";
import { broadcastResponseToMainFrame } from "@azure/msal-browser/redirect-bridge";

export const AuthCallback = () => {
  useEffect(() => {
    (async () => {
      try {
        // Call the bridge method to broadcast the response
        await broadcastResponseToMainFrame();
      } catch (error) {
        if (error instanceof Error) {
          // no action
        }
      }
    })();
  }, []);

  return <div>Authenticating...</div>;
};

export default AuthCallback;
